@if(icon !== null){
  <ion-button (keydown.enter)="presentSingleStatusModal()"
    class="ion-toolbar-button ion-no-padding-top ion-no-padding-end ion-no-margin-right"
    (click)="presentSingleStatusModal()" fill="solid" style="--border-radius: 1vh 0 0 1vh;">
    <ion-icon [color]="icon.color" [name]="icon.name" size="medium"
      [style]="'transform: scale(1.3); filter: drop-shadow(0 0.063rem 0.063rem var(' + icon.style + '));'"></ion-icon>
  </ion-button>
}
